// extracted by mini-css-extract-plugin
var _1 = "yJ4mvN7HoaF8q9V6oag9";
var _2 = "M1sPF19GjiSJW5JQCnL5";
var _3 = "TJU6CJ9ihaNOtvQSBMas";
var _4 = "Rlr7GdNFFZYCJKaezY7k";
var _5 = "kS67b9fehFzv7nh1c_9G";
var _6 = "U9O8g812EZ3OLBvNJjcM";
var _7 = "k56ZwfrNy4BEcJq1Xnr5";
export { _1 as "card", _2 as "image", _3 as "inner", _4 as "loaderWrap", _5 as "sectionHeading", _6 as "wallSizes", _7 as "wallsGrid" }
